<template>
  <div>
    <vs-button color="danger" type="flat" @click="showid">
      <span class="material-icons-outlined"> delete </span>
    </vs-button>

    <b-modal centered :id="'bmodalexample' + id" @ok="delAttrAsset">
      <template #modal-title> Remove Field </template>
      <div class="d-block">
        <p>
          Are you sure you would like to remove
          <b-badge variant="secondary">{{ attrName }}</b-badge> ?
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ax from "axios";

export default {
  props: {
    assetID: Number,
    id: Number,
    attrName: String,
    type: String,
  },
  data() {
    return {
      assetID: "",
      id: "",
      attrName: "",
      type: "",
    };
  },
  methods: {
    showid() {
      this.$bvModal.show("bmodalexample" + this.id);
      console.log("id :", this.id);
    },
    async delAttrAsset() {
      switch (this.type) {
        case "Text":
          this.delAttrAssetTxtType();
          break;
        case "Number":
          this.delAttrAssetNumberType();
          break;
        case "Date":
          this.delAttrAssetDateType();
          break;
        case "Currency":
          this.delAttrAssetCurrencyType();
          break;
      }
    },
    async delAttrAssetTxtType() {
      await ax({
        method: "delete",
        url: `${this.$url2}asset/del-textattr-asset`,
        data: {
          assetID: 18,
          assetFieldTextID: this.id,
        },
      })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
        });
    },
    async delAttrAssetNumberType() {
      await ax({
        method: "delete",
        url: `${this.$url2}asset/del-numattr-asset`,
        data: {
          assetID: 18,
          assetFieldNumID: this.id,
        },
      })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
        });
    },
    async delAttrAssetCurrencyType() {
      await ax({
        method: "delete",
        url: `${this.$url2}asset/del-curattr-asset`,
        data: {
          assetID: 18,
          assetFieldCURID: this.id,
        },
      })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
        });
    },
  },
};
</script>

<style scoped>
button.vs-component.vs-button.vs-button-danger.vs-button-flat {
  padding: 0px !important;
}
</style>
